








import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
// @ts-ignore
import store from "../../../store";
// @ts-ignore
import MessageHelper from "../../../helpers/MessageHelper";
import type {Player} from "../../../../types";
import MafiaVoting from "../../Automations/Mafia/MafiaVoting.vue";
import SeatExternalVotingResults from "../../Voting/SeatExternalVotingResults.vue";
import EventApi from "../../../api/EventsApi";

const NEXT_SPEAKER = 'nextSpeaker';

@Component({
    components: {SeatExternalVotingResults, MafiaVoting},
})

/** Кнопки голосования за игру */
export default class DetectiveClubButtons extends Vue {
    @Prop({required: true}) private readonly isMaster!: boolean;
    @Prop({required: true}) private readonly masterId!: string|null;
    @Prop({required: true}) private readonly seat!: Player;
    mounted(): void
    {
    }

    beforeDestroy():void
    {
    }

    private get gameState(): any
    {
        return store.getters.getGameState;
    }

    private get playerId(): string
    {
        return store.getters.getPlayerId;
    }

    /** Видимость кнопки "Передать слово" */
    private get isNextSpeakerButtonVisible(): boolean
    {
        const dcButtons = this.gameState.zones.chat.buttons.detective_club;

        if (!dcButtons) {
            return false;
        }

        const button = this.gameState.zones.chat.buttons.detective_club.nextSpeaker;

        if (!this.isMaster || this.playerId !== this.masterId) {
            return false;
        }

        if (typeof button === 'undefined' || !button.enabled) {
            return false;
        }

        if (!button.visibleFor.length) {
            return true;
        }

        if (!button.visibleFor.includes(this.playerId)) {
            return false;
        }

        if (!button) {
            return false;
        }

        return button.enabled;
    }

    /** Нажатие на кнопку "Передать слово" */
    private clickNextSpeakerButton(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        MessageHelper.clickCustomButtonMessage({
            zone: 'chat',
            type: NEXT_SPEAKER,
        });
    }
}
